import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::index
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:18
* @route '/locations'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/locations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::index
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:18
* @route '/locations'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::index
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:18
* @route '/locations'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::index
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:18
* @route '/locations'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::index
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:18
* @route '/locations'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::index
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:18
* @route '/locations'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::index
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:18
* @route '/locations'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleCountry
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:45
* @route '/locations/countries/{country}/toggle'
*/
export const toggleCountry = (args: { country: string | { id: string } } | [country: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggleCountry.url(args, options),
    method: 'post',
})

toggleCountry.definition = {
    methods: ["post"],
    url: '/locations/countries/{country}/toggle',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleCountry
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:45
* @route '/locations/countries/{country}/toggle'
*/
toggleCountry.url = (args: { country: string | { id: string } } | [country: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { country: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { country: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            country: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        country: typeof args.country === 'object'
        ? args.country.id
        : args.country,
    }

    return toggleCountry.definition.url
            .replace('{country}', parsedArgs.country.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleCountry
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:45
* @route '/locations/countries/{country}/toggle'
*/
toggleCountry.post = (args: { country: string | { id: string } } | [country: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggleCountry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleCountry
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:45
* @route '/locations/countries/{country}/toggle'
*/
const toggleCountryForm = (args: { country: string | { id: string } } | [country: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleCountry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleCountry
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:45
* @route '/locations/countries/{country}/toggle'
*/
toggleCountryForm.post = (args: { country: string | { id: string } } | [country: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleCountry.url(args, options),
    method: 'post',
})

toggleCountry.form = toggleCountryForm

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleState
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:65
* @route '/locations/states/{state}/toggle'
*/
export const toggleState = (args: { state: string | { id: string } } | [state: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggleState.url(args, options),
    method: 'post',
})

toggleState.definition = {
    methods: ["post"],
    url: '/locations/states/{state}/toggle',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleState
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:65
* @route '/locations/states/{state}/toggle'
*/
toggleState.url = (args: { state: string | { id: string } } | [state: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { state: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { state: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            state: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        state: typeof args.state === 'object'
        ? args.state.id
        : args.state,
    }

    return toggleState.definition.url
            .replace('{state}', parsedArgs.state.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleState
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:65
* @route '/locations/states/{state}/toggle'
*/
toggleState.post = (args: { state: string | { id: string } } | [state: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: toggleState.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleState
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:65
* @route '/locations/states/{state}/toggle'
*/
const toggleStateForm = (args: { state: string | { id: string } } | [state: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleState.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Settings\LocationManagementController::toggleState
* @see app/Http/Controllers/Admin/Settings/LocationManagementController.php:65
* @route '/locations/states/{state}/toggle'
*/
toggleStateForm.post = (args: { state: string | { id: string } } | [state: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggleState.url(args, options),
    method: 'post',
})

toggleState.form = toggleStateForm

const locations = {
    index: Object.assign(index, index),
    toggleCountry: Object.assign(toggleCountry, toggleCountry),
    toggleState: Object.assign(toggleState, toggleState),
}

export default locations